import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

import { billing, ProductSlug, UpgradeSource } from 'common/billing'

/**
	•	Just for the purpose of the annual expansion experiment
	•	https://linear.app/manychat/issue/GRO-227/annual-expansion-proactively-upsell-monthly-subscribers-to-annual
	•
	•	Using the deeplink mechanism as a workaround because the requestUpgrade API doesn't allow opening the billing upgrade modal
	•	with a current plan and annual period, without any ability
	•
	•	TODO: if the experiment is successful before rollout, need to make a request to the Billing Team to extend the requestUpgrade API
*/
export const useAnnualExpansionRequestUpgrade = (source: UpgradeSource, slug?: ProductSlug) => {
  const [_, setSearchParams] = useSearchParams()

  const requestUpgrade = useCallback(async () => {
    // because of the async fetching of the pro data we don't always have an info about current product
    if (!slug) {
      return
    }

    setSearchParams({ products: slug }, { replace: true })

    await billing.requestUpgrade({
      isDeepLink: true,
      isManagement: true,
      source,
    })

    setSearchParams({}, { replace: true })
  }, [slug, source, setSearchParams])

  return requestUpgrade
}
